<template>
  <div>
    <v-autocomplete :error-messages="validationMessage" :items="groups" :label="label" :rules="rules" item-text="name" item-value="id" v-model="contextModel">
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: "DelegationRateGroupSelect",
  props: {
    model: {
      required: true
    },
    validationMessage: {
      type: Array,
      default: function() {
        return [];
      }
    },
    label: {
      type: String,
      default: "Grupa użytkowników"
    },
    rules: {
      required: false,
      default: function() {
        return [];
      }
    },
    exceptGroupId: {
      required: false,
      default: null
    }
  },
  watch: {},
  data: () => ({
    groups: [{ id: null, name: "Ustawienia systemowe" }]
  }),
  computed: {
    contextModel: {
      set: function(value) {
        this.$emit("update:model", value);
      },
      get: function() {
        return this.model;
      }
    }
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.axios.get("settings/delegation-group/list").then(resp => {
        for (let group of resp.data) {
          if (this.exceptGroupId == null || this.exceptGroupId !== group.id) {
            group.id = group.id.toString();
            this.groups.push(group);
          }
        }
      });
    }
  }
};
</script>

<style scoped></style>
